/**
 * Аналитика Telegram мини-аппа — Яндекс.Метрика (клиентский счётчик).
 * Включается ТОЛЬКО если задан VITE_YANDEX_METRIKA_ID (иначе полностью no-op).
 * Работает в Telegram WebView; всё в try/catch, никогда не ломает UX.
 */
const METRIKA_ID = (import.meta.env.VITE_YANDEX_METRIKA_ID as string | undefined)?.trim() || ''

declare global {
  interface Window {
    ym?: ((...args: unknown[]) => void) & { a?: unknown[]; l?: number }
  }
}

let ymLoaded = false

export function initAnalytics(): void {
  if (!METRIKA_ID || ymLoaded || typeof document === 'undefined') return
  ymLoaded = true
  try {
    const w = window as unknown as { ym?: (...a: unknown[]) => void }
    w.ym = w.ym || function (...args: unknown[]) {
      ;(w.ym as unknown as { a: unknown[][] }).a = (w.ym as unknown as { a?: unknown[][] }).a || []
      ;(w.ym as unknown as { a: unknown[][] }).a.push(args)
    }
    ;(w.ym as unknown as { l: number }).l = Date.now()
    const id = 'ym-code'
    if (!document.getElementById(id)) {
      const s = document.createElement('script')
      s.type = 'text/javascript'; s.async = true; s.id = id
      s.src = 'https://mc.yandex.ru/metrika/tag.js'
      const f = document.getElementsByTagName('script')[0]
      f?.parentNode?.insertBefore(s, f)
    }
    window.ym?.(Number(METRIKA_ID), 'init', {
      clickmap: true, trackLinks: true, accurateTrackBounce: true, webvisor: true, trackHash: true,
    })
  } catch {
    /* analytics must never break the app */
  }
}

// init уже отправил первый просмотр; SPA-переходы — pushState (не hash) → шлём hit вручную,
// пропуская самый первый вызов (чтобы не задвоить стартовый).
let firstHitSkipped = false
export function trackPageView(path?: string): void {
  if (!firstHitSkipped) { firstHitSkipped = true; return }
  if (!METRIKA_ID) return
  try { window.ym?.(Number(METRIKA_ID), 'hit', path || (typeof location !== 'undefined' ? location.pathname : '/')) } catch { /* noop */ }
}
